import { customElement, state } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { CSSResultGroup, TemplateResult, html } from 'lit';
import { ResizeController } from '../../controllers/resize-controller';
import componentStyles from './tufts-in-page-navigation.css.lit';

@customElement('tufts-in-page-navigation')
export class TuftsInPageNavigation extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  resizeController: ResizeController = new ResizeController(this);
  @state() isMobile: boolean;

  nodesWithJumpLink: HTMLElement[] = [];

  connectedCallback() {
    super.connectedCallback();
    this.nodesWithJumpLink = this.generateJumpLinks();
    this.hideSectionIfEmpty();
  }

  generateJumpLinks(): HTMLElement[] {
    const nodesWithJumpLink: HTMLElement[] = [];

    // Find all tufts-container elements
    const tuftsContainers = document.querySelectorAll('tufts-container');
    // Apply smooth scrolling behavior to the HTML element
    if (tuftsContainers) {
      const htmlTag: HTMLHtmlElement | null = document.querySelector('html');
      htmlTag?.setAttribute('style', 'scroll-behavior: smooth;');
    }
    // Iterate over each tufts-container element
    tuftsContainers.forEach(container => {
      // Check if the element has a jump-link attribute
      const hasJumpLink = container.getAttributeNames().includes('jump-link');

      if (hasJumpLink) {
        // Get the ID and title from the element
        const idElement = container.getAttribute('id');
        const titleElement = container.getAttribute('jump-link');

        if (idElement && titleElement) {
          // Create an li container and an anchor element
          const liContainer = document.createElement('li');
          const anchor = document.createElement('a');

          // Set the anchor's text and href attributes
          anchor.innerText = titleElement;
          anchor.setAttribute('href', `#${idElement}`);
          anchor.className = 'link-navigation';

          // Append the anchor to the li container
          liContainer.appendChild(anchor);

          // Add the li container to the array
          nodesWithJumpLink.push(liContainer);
        }
      }
    });
    return nodesWithJumpLink;
  }
  hideSectionIfEmpty() {
    // Check if there are no jump links generated
    if (this.nodesWithJumpLink.length === 0) {
      // Attempt to find a parent section that directly contains a 'tufts-container' child
      const targetSection = this.closest(
        'section:has(> tufts-container)'
      ) as HTMLElement;
      if (targetSection) {
        // If such a section is found, hide it
        targetSection.style.display = 'none';
      }
    }
  }

  render(): TemplateResult {
    this.isMobile = this.resizeController.currentBreakpointRange === 0;
    if (this.nodesWithJumpLink.length === 0) {
      return html``;
    }
    if (this.isMobile) {
      return html` <details>
        <summary>
          <legend>-- Explore this page --</legend>
        </summary>
        <ul>
          ${this.nodesWithJumpLink}
        </ul>
      </details>`;
    }
    return html`
      <ul class="desktop">
        ${this.nodesWithJumpLink}
      </ul>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-in-page-navigation': TuftsInPageNavigation;
  }
}
